import { ref, getCurrentInstance } from 'vue';
import { setCookie, removeCookie, getCookie } from '@/utils/api';
import { useRouter } from '@/utils/vue-api';

export function useEnvironment() {
	const vm = getCurrentInstance();

	const router = useRouter();
	const currentEnvironment = ref('');

	/**
	 * 环境识别与处理
	 * @param {object} route - 当前路由对象
	 */
	const handleEnvironment = () => {
		const { release, ...cleanQuery } = vm.proxy.$route.query;

		if (release && ['test_001', 'pro_001'].includes(release)) {
			// 存在有效 release 参数，写入 cookie 并清除 URL 参数
			console.log('检测到有效 release 参数:', release);
			setCookie('release', release);
			setCookie('symbol', 'clean');

			router.replace({
				path: vm.proxy.$route.path,
				query: cleanQuery
			});
			currentEnvironment.value = release;
		} else {
			// 无有效 query 参数，读取 cookie 状态
			const cookieRelease = getCookie('release');
			const cookieSymbol = getCookie('symbol');

			if (cookieRelease && cookieSymbol === 'clean') {
				currentEnvironment.value = cookieRelease;
				// console.log('从 cookie 读取环境:', cookieRelease);
			} else {
				// 清理无效的 cookie
				if (cookieRelease || cookieSymbol) {
					removeCookie('release');
					removeCookie('symbol');
				}
				currentEnvironment.value = '';
				// console.log('当前为标准环境');
			}
		}
	};

	/**
	 * 切换到标准环境
	 */
	const switchToStandardEnv = () => {
		console.log('切换到标准环境');
		removeCookie('release');
		removeCookie('symbol');
		currentEnvironment.value = '';
		// 刷新页面回到默认状态
		window.location.reload();
	};

	return {
		currentEnvironment,
		handleEnvironment,
		switchToStandardEnv
	};
}
